import Vue from "vue";
import router from "./router";
import store from "./store.js";
import {initGoogleMap } from "./api.js";
import VeeValidate from "vee-validate";
import VueSweetalert2 from "vue-sweetalert2";

import VueFinalModal from "vue-final-modal";
Vue.use(VueFinalModal());

import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);

import VueIntercom from "vue-intercom";
Vue.use(VueIntercom, { appId: "'" + process.env.INTERCOM_APP_ID + "'" });

// Users
import BusinessUsers from "./components/both/business-users/BusinessUsers";
import OrderCoffee from "./components/both/OrderCoffee";

// Sender
import BookingForm from "./components/sender/booking-form/BookingForm";
import DangerousGoods from "./components/sender/dangerous-goods/DangerousGoods";
import Locations from "./components/sender/locations/LocationsPage";
import CurrentBookings from "./components/sender/bookings/current/CurrentBookings";
import DamageClaims from "./components/sender/damage-claims/DamageClaims";
import BookingDetails from "./parents/sender/BookingDetails";
import SenderDashboard from "./parents/sender/Dashboard";
import Manifest from "./components/sender/bookings/Manifest";
import ManifestTable from "./components/sender/bookings/ManifestTable";
import FreightMateDashboard from "./parents/sender/FreightMateDashboard";
import TrackingPage from "./components/sender/tracking/TrackingPage";
import DashboardPage from "./components/dashboard/DashboardPage";
import BookingsPage from "./components/bookings/BookingsPage";

// Carrier
import FixedRates from "./components/carrier/fixed-rates/FixedRates";
import CarrierDashboard from "./parents/carrier/dashboard/CarrierDashboard";
import CarrierBookingDetailsPage from "./components/bookings/booking-details/CarrierBookingDetailsPage";
import CarrierAnalytics from "./parents/carrier/Analytics";
import CarrierScheduleMonitor from "./parents/carrier/ScheduleMonitor";
import CarrierScheduleMonitorTv from "./parents/carrier/ScheduleMonitorTv";
import CarrierTruckMetrics from "./parents/carrier/TruckMetrics";
import CarrierSettingsTrucks from "./parents/carrier/settings/Trucks";
import CarrierQrReport from "./parents/carrier/QrReport";
import CarrierDifot from "./parents/carrier/CarrierDifot";
import RunSheets from "./parents/carrier/RunSheets";
import CarrierScheduleMonitorTvTw from "./parents/carrier/ScheduleMonitorTvTw";
import CarrierServiceRegions from "./parents/carrier/ServiceRegions";

// Utils
import GlobalAlert from "./components/utils/GlobalAlert";
import Modal from "./components/utils/Modal";
import LoadingAlert from "./components/utils/LoadingAlert";
import FileUploader from "./components/utils/FileUploader";
import Multiselect from "vue-multiselect";
import FileGenerating from "./components/utils/FileGenerating";
import BookingSearch from "./components/global/BookingSearch";
import ConfirmModal from "./components/utils/ConfirmModal";
import LaravelVuePagination from "laravel-vue-pagination";

// Public
import AboutMap from "./components/public/about/AboutMap";
import QuoteEstimator from "./parents/public/QuoteEstimator";
import GuestBookingDetails from "./parents/public/GuestBookingDetails";
import GuestTrackTruck from "./parents/public/GuestTrackTruck";
import TrackBookings from "./parents/public/TrackBookings";
import GuestLogin from "./parents/public/GuestLogin";
import ResetPassword from "./parents/public/ResetPassword";
import Register from "./parents/public/Register";
import Faqs from "./parents/public/Faqs";
import Tracker from "./parents/public/Tracker";

import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues

// Calendar
import VCalendar from "v-calendar";
Vue.use(VCalendar);

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    let vm = vnode.context;
    let callback = binding.value;
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        return callback.call(vm, event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.component("GmapCluster", GmapCluster);

Vue.component("multiselect", Multiselect);
Vue.component("loading-alert", LoadingAlert);
Vue.component("pagination", LaravelVuePagination);
Vue.component("confirm-modal", ConfirmModal);

window.Event = new Vue();

Vue.use(VueSweetalert2);

Vue.use(VeeValidate, { inject: false });
Vue.use(require("vue-smoothscroll"));

Vue.component(
  "passport-personal-access-tokens",
  require("./components/passport/PersonalAccessTokens.vue").default
);

Vue.component(
  "api-requests",
  require("./components/both/ApiRequests.vue").default
);

//Vue Directive Tooltip
import Tooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/css/index.css";

Vue.use(Tooltip, {
  delay: 200,
  placement: "bottom",
  triggers: ["hover"],
  offset: 5
});

window.moment = require("moment");
import { extendMomentBusiness } from "./utility/momentjs-business.mjs";
extendMomentBusiness();

import CarrierPage from "./components/carrier/CarrierPage";

// Add the map initialization function to the Vue prototype
Vue.prototype.$initGoogleMap = initGoogleMap;

new Vue({
  el: "#app",
  components: {
    BookingForm,
    DangerousGoods,
    Locations,
    CurrentBookings,
    LoadingAlert,
    DamageClaims,
    Modal,
    GlobalAlert,
    FileUploader,
    FixedRates,
    FileGenerating,
    BookingSearch,
    CarrierDashboard,
    AboutMap,
    QuoteEstimator,
    Faqs,
    BookingDetails,
    BusinessUsers,
    GuestBookingDetails,
    CarrierBookingDetailsPage,
    CarrierAnalytics,
    CarrierScheduleMonitor,
    CarrierScheduleMonitorTv,
    CarrierScheduleMonitorTvTw,
    CarrierSettingsTrucks,
    SenderDashboard,
    CarrierTruckMetrics,
    OrderCoffee,
    GuestTrackTruck,
    Manifest,
    TrackBookings,
    GuestLogin,
    ResetPassword,
    Register,
    ManifestTable,
    CarrierQrReport,
    CarrierDifot,
    RunSheets,
    Tracker,
    FreightMateDashboard,
    CarrierServiceRegions,
    DashboardPage,
    BookingsPage,
    TrackingPage,
    CarrierPage
  },
  router,
  store
});
